import classNames from 'classnames';
import React from 'react';
import { TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { BaseViewTaxForm } from './base-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';
import { TaxOptionTypeKey, TaxOptionTypeI18nKey } from '../../constants';
import { getTaxOptionType, BaseViewTaxFormList } from '../../utils';

const { getTaxOptionLabel } = TaxUtils;

export const BrazilViewTaxForm = ({
  i18n,
  data,
  filledData,
  taxSchema,
  permissions,
}) => {
  const taxOptionType = getTaxOptionType({ uiObject: data, permissions });
  return (
    <div className={classNames('brazil-view-taxform', taxOptionType && `${taxOptionType}-view-taxform`)}>
      <BaseViewTaxForm
        i18n={i18n}
        name={TaxOptionTypeKey}
        label={i18n.getString(TaxOptionTypeI18nKey)}
        value={taxOptionType ? getTaxOptionLabel(taxOptionType, i18n) : i18n.getString(_TL_('(Not set)'))}
      />
      {taxOptionType && (
        <BaseViewTaxFormList
          i18n={i18n}
          uiObject={filledData}
          taxSchema={taxSchema}
        />
      )}
    </div>
  );
};

BrazilViewTaxForm.propTypes = ViewTaxFormPropTypes;
